<template>
  <div class="map-box">
    <div class="row">
      <div class="col-6 col-lg-4 offset-lg-1">
        <div class="map-box__track map-box__track--pink" @mouseover="over('run')" @mouseleave="leave()">
          <!-- Corrida, Caminhada e Revezamento -->
          Corrida e Revezamento Duplo Misto: 5km - 2 voltas
          <br>
          <br>
          Caminhada: 2,5km - 1 volta
        </div>
      </div>
      <div class="col-6 col-lg-4">
        <div class="map-box__track map-box__track--green" @mouseover="over('kids')" @mouseleave="leave()">
          <!-- Caminhada Kids -->
          Caminhada Kids: 1km - 1 volta
        </div>
      </div>
      <div class="col-12">
        <div class="map-box__image">
          <img :src="track" alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data: () => ({
      track: require('@/images/map.jpg'),
    }),
    methods: {
      over(track) {
        switch (track) {
          case 'run':
          this.track = require('@/images/map-run.jpg')
          break
          case 'kids':
          this.track = require('@/images/map-kids.jpg')
          break
        }
      },
      leave() {
        this.track = require('@/images/map.jpg')
      }
    }
  }
</script>


<style lang="scss" scoped>
  .map-box
  {
    &__image
    {
      position: relative;
      z-index: 0;
      top: -30px;

      margin-right: calc(50% - 50vw);
      margin-left: calc(50% - 50vw);

      overflow-x: hidden;

      @media (min-width: 992px)
      {
        top: -100px;

        padding: 0;
      }

      img
      {
        max-width: 150%;
        margin: 0 -25%;
        height: auto;
        @media (min-width: 992px)
        {
          max-width: 100%;
          margin: 0;
        }
      }
    }

    &__track
    {
      font-size: 17px;
      line-height: 22px;

      position: relative;
      z-index: 10;

      display: flex;

      user-select: none;

      &::before
      {
        display: block;
        flex: 0 0 auto;

        width: 22px;
        height: 22px;
        margin-right: 22px;

        content: " ";

        border-radius: 50%;
      }

      &--pink
      {
        color: #d539d4;

        &::before
        {
          background-color: #d539d4;
        }
      }

      &--green
      {
        color: #01ffb5;

        &::before
        {
          background-color: #01ffb5;
        }
      }
    }
  }
</style>
